module.exports = __webpack_public_path__ + "static/media/QC_Document_Template_1.55f385cf.png";